import React, { useRef } from 'react';
import { useMessageGetter } from 'react-message-context';
import { Button } from '..';
import { showNotification } from '../../../context/appActions';
import { NotificationType, useAppDispatch } from '../../../context/appContext';

export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export type FileInputValue = FileList | null;

type InputProps = {
  label?: string;
  onChange: (files: FileInputValue) => void;
  multiple?: boolean;
};

export const FileInput: React.FunctionComponent<InputProps> = (props) => {
  const appDispatch = useAppDispatch();
  const t = useMessageGetter('');
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleOnClick = () => {
    fileInputRef.current?.click();
  };
  const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) {
      props.onChange(null);
      return;
    }

    const validFiles = Array.from(files).filter((file) => {
      const isValidFormat = file.type.startsWith('image/') || file.type === 'application/pdf';
      const isValidSize = file.size <= MAX_FILE_SIZE_BYTES;
      return isValidFormat && isValidSize;
    });

    if (validFiles.length !== files.length) {
      await showNotification(
        appDispatch,
        t('forms.files.error.invalidImageOrPdf', { maxSixe: MAX_FILE_SIZE_MB }),
        NotificationType.ERROR
      );
      props.onChange(null);
      return;
    }

    props.onChange(files);
  };

  return (
    <Button icon="plus" type="button" onClick={handleOnClick}>
      <input
        ref={(e) => {
          fileInputRef.current = e;
        }}
        onChange={handleOnChange}
        type="file"
        multiple={props.multiple}
        accept={'image/*,application/pdf'}
        style={{ display: 'none' }}
      />
      {props.label ?? t('input.addAttachment')}
    </Button>
  );
};
